import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/lems-v1/images/close-black-icon.svg'


const _hoisted_1 = {
  class: "modal fade",
  id: "deleteFile",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog leaveModal",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "leaveModal-header" }
const _hoisted_5 = { class: "leaveModal-btm" }
const _hoisted_6 = {
  id: "deleteFileCancelBtn",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  class: "v1-button-outline-black"
}
const _hoisted_7 = {
  id: "deleteFileYesBtn",
  "data-bs-dismiss": "modal",
  class: "v1-button-outline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            type: "button",
            id: "deleteFilePopClose",
            class: "close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            })
          ], -1)),
          _createElementVNode("h1", null, _toDisplayString(_ctx.constants.DELETE_FILE_POP_TEXT), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1),
          _createElementVNode("button", _hoisted_7, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
        ])
      ])
    ])
  ]))
}